define([
    "./monitoringIntegrationModule",
    "./monitoringIntegration",
    "./monitoringIntegrationModule",
    "./monitoringIntegrationRouter",
    "./monitoringIntegrationService",
    "./monitoringIntegrationUrls",
    "./nlgMonitoringIntegrationUrlConfiguration",
], function (monitoringIntegrationModule) {
    return {monitoringIntegrationModule};
})